// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa23b6e9","239":"e4511a07","732":"549fba39"}[chunkId] + ".chunk.js";
};